/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, Input, OnChanges} from '@angular/core';
import {TranslateModule} from '@ngx-translate/core';
import {APP_SHARED} from '../common/app-shared';

@Component({
  standalone: true,
  imports: [...APP_SHARED, TranslateModule],
  selector: 'line-item-status-label',
  template: `<span *ngIf="adjustedState" class="label" [ngClass]="labelClass[adjustedState]">{{ ('lineItem.userState.' + adjustedState) | ogTranslate }}</span>`
})
export class LineItemStatusLabelComponent implements OnChanges {
  @Input() userState: string;
  adjustedState: string;

  readonly labelClass: Record<string, string> = {
    INCOMPLETE: 'label-warning',
    APPROVED: 'label-success',
    PAUSED: 'label-warning',
    PROPOSED: 'label-info',
    REJECTED: 'label-danger',
    SUBMITTED: 'label-primary',
    RESERVED: 'label-default',
    STOPPED: 'label-danger',
    COMPLETED: 'label-success'
  };

  ngOnChanges(): void {
    this.adjustedState = this.userState;
  }
}
